goog.provide("shadow.js.shim.module$react_draggable");
goog.provide("module$shadow_js_shim_module$react_draggable");
shadow.js.shim.module$react_draggable = shadow.js.nativeProvides["react-draggable"] = shadow$bridge("react-draggable");
module$shadow_js_shim_module$react_draggable.default = shadow.js.shim.module$react_draggable;
